import Link from 'components/link/link';
import Image from 'next/image';
import { getStrapiMedia } from 'utils';
import { useRouter } from 'next/router';
import { contentRecordHref } from 'lib/content-links';

interface ProjectsItemProps {
  data: any;
  index: number;
  priority?: boolean;
}

interface BadgeProp {
  Title: string;
}

const ProjectsItem: React.FC<ProjectsItemProps> = ({ data, index, priority = false }) => {
  const { locale } = useRouter();
  const attrs = data.project?.data?.attributes;
  const href = contentRecordHref(attrs, '/client', locale);

  if (!attrs || !href) {
    return null;
  }

  return (
    <div className="project-item">
      <Link
        href={href}
        OpenInNewTab={attrs.OpenInNewTab}
        className="project-item__inner"
      >
        <Image
          alt={attrs.Image?.data?.attributes?.alternativeText || ""}
          src={getStrapiMedia(attrs.Image)}
          fill
          sizes="(max-width: 767px) calc(100vw - 48px), (max-width: 1023px) calc((100vw - 134px) / 2), (max-width: 1439px) calc((100vw - 240px) / 3), 400px"
          loading={priority ? "eager" : "lazy"}
          fetchPriority={priority && index === 0 ? "high" : undefined}
          style={{
            objectFit: 'cover',
          }}
        />
        <div className="project-item__text">
          <h6>{attrs.Title}</h6>
          <p>{attrs.Subtitle}</p>
        </div>
        {attrs.Badge && (
          <div className="project-item__badge">
            {attrs.Badge.map((item: BadgeProp, index: number) => (
              <div key={index} className="project-item__badge-inner">
                <span>{item.Title}</span>
              </div>
            ))}
          </div>
        )}
      </Link>
    </div>
  );
};

export default ProjectsItem;
